export default {
  nav: { models: "Modèles", gallery: "Galerie", fleet: "Flottes & B2B", contact: "Contact" },
  cta: { testDrive: "Réserver un essai" },
  hero: {
    overline: "Importateur général officiel pour la Suisse",
    title: "L'avenir est électrique. Maintenant en Suisse.",
    subtitle: "Les véhicules électriques Skyworth allient grande autonomie, technologie de pointe et un accompagnement suisse de confiance – de l'essai routier au service après-vente.",
    btnModels: "Découvrir les modèles",
  },
  stats: [
    { value: "30'000+", label: "Collaborateurs dans le monde au sein du groupe Skyworth" },
    { value: "7 ans", label: "Garantie constructeur sur le BE11" },
    { value: "489 km", label: "Autonomie WLTP (BE11 Long Range)" },
    { value: "100 %", label: "Accompagnement directement depuis la Suisse" },
  ],
  showcase: {
    overline: "Modèles",
    title: "Un modèle pour chaque exigence.",
    allLink: "Tous les modèles en détail",
    discover: "Découvrir",
  },
  brand: {
    overline: "La marque",
    title: "Du groupe d'électronique au pionnier de l'électromobilité.",
    text: "Skyworth est un groupe technologique mondial de plus de 30'000 collaborateurs – de l'électronique grand public aux solutions énergétiques intelligentes. Avec Skywell, la marque transpose ce savoir-faire sur la route : des véhicules électriques robustes, généreusement équipés et couverts par de solides garanties.",
    bullets: [
      "Fondée en 2000 – plus de deux décennies d'expérience",
      "Des véhicules en circulation en Europe, en Asie et en Australie",
      "Auto + Home : du véhicule aux solutions énergétiques pour la maison",
    ],
  },
  videoSection: {
    overline: "Film",
    title: "Skyworth en mouvement.",
    text: "Découvrez le design, la technologie et le plaisir de conduite de la gamme Skyworth dans le film officiel de la marque.",
  },
  fleetHome: {
    overline: "Flottes & B2B",
    title: "L'électromobilité pour votre entreprise.",
    text: "Du véhicule de fonction individuel à la flotte complète : nous vous conseillons personnellement sur le choix des véhicules, l'infrastructure de recharge et l'exploitation – avec un contact direct avec le constructeur et un service depuis la Suisse.",
    button: "Faire une demande de flotte",
  },
  service: {
    overline: "Service & confiance",
    title: "Votre interlocuteur en Suisse.",
    cards: [
      { title: "Importateur général officiel", text: "Accès direct au constructeur – sans détours, avec tous les avantages pour vous." },
      { title: "Showroom & service en Suisse", text: "Conseil personnalisé, essais routiers et entretien directement sur place." },
      { title: "Garantie & pièces de rechange sur place", text: "Garantie constructeur de 7 ans et approvisionnement suisse en pièces détachées." },
    ],
  },
  ctaSection: {
    title: "Convainquez-vous vous-même – lors d'un essai routier.",
    text: "Vivez l'autonomie, le silence et le plaisir de conduite en direct. Nous vous recontactons sous 24 heures avec une proposition de rendez-vous.",
    btnPrimary: "Réserver un essai maintenant",
  },
  footer: {
    tagline: "Importateur général officiel des véhicules électriques Skyworth & Skywell en Suisse. Showroom, service, garantie et pièces de rechange – tout sur place.",
    navTitle: "Navigation",
    contactTitle: "Contact",
    rights: "SkyworthCars Suisse. Tous droits réservés.",
    legal: "Mentions légales & politique de confidentialité à suivre.",
    youtube: "Skyworth Auto sur YouTube",
  },
  galleryPage: {
    overline: "Galerie",
    title: "Grandes images. Tous les modèles.",
    subtitle: "Photos et vidéos officielles des véhicules – choisissez un modèle et parcourez la galerie.",
    explore: "Découvrir le modèle",
    videoTitle: "Vidéo",
  },
  modelsPage: {
    overline: "Gamme de modèles",
    title: "Tous les modèles Skyworth pour la Suisse.",
    subtitle: "Du SUV électrique efficient au fleuron de luxe – découvrez la gamme avec photos, données techniques et équipements.",
    loading: "Chargement des modèles …",
  },
  detail: {
    back: "Tous les modèles",
    testDrive: "Réserver un essai",
    consult: "Demander conseil",
    about: "À propos de ce modèle",
    specs: "Données techniques",
    disclaimer: "Toutes les indications sans garantie. Sous réserve de modifications et d'erreurs.",
    photos: "Photos & impressions",
    videoSoon: "Rubrique vidéo : les vidéos officielles des modèles suivront prochainement.",
    ctaTitle: "Découvrir le {{name}} en vrai ?",
    ctaBtn: "Convenir d'un essai",
    notFound: "Modèle introuvable",
    notFoundBack: "Retour à l'aperçu des modèles",
    loading: "Chargement …",
  },
  testDrivePage: {
    overline: "Essai routier",
    title: "Réservez votre essai routier.",
    subtitle: "Choisissez votre modèle et votre date souhaités – nous vous recontactons sous 24 heures avec une confirmation.",
  },
  contactPage: {
    overline: "Contact",
    title: "Nous sommes à votre écoute.",
    subtitle: "Des questions sur un modèle, la disponibilité ou le service ? Écrivez-nous ou appelez-nous directement.",
    directTitle: "Contact direct",
    showroomTitle: "Showroom & service",
    hours: "Horaires d'ouverture sur demande",
  },
  fleetPage: {
    overline: "Flottes & B2B",
    title: "Votre flotte. Électrique. Accompagnée en Suisse.",
    subtitle: "Réduisez vos coûts d'exploitation et vos émissions – avec les véhicules électriques Skyworth, un conseil personnalisé et un service fiable directement depuis la Suisse.",
    scrollBtn: "Faire une demande",
    cards: [
      { title: "Solutions de flotte", text: "Du véhicule de fonction individuel à la flotte complète – des offres sur mesure pour les entreprises suisses." },
      { title: "Infrastructure de recharge", text: "Conseil sur les solutions de recharge sur le site de l'entreprise et Vehicle-to-Load pour un usage mobile." },
      { title: "Partenariat de service", text: "Contact direct avec l'importateur général : gestion des garanties, pièces de rechange et entretien d'une seule source." },
    ],
    vans: {
      overline: "Véhicules utilitaires",
      title: "Pour votre logistique aussi : le Skyworth HONGTU Cargo Van.",
      text: "Fourgons et véhicules utilitaires électriques pour la livraison urbaine – disponibles sur demande pour votre flotte.",
      button: "Données techniques & détails du HONGTU V9",
      cargoLabel: "HONGTU Cargo Van · Transport de marchandises",
      passengerLabel: "HONGTU Passenger Van · Transport de personnes",
    },
    formSection: { overline: "Demande de flotte", title: "Parlez-nous de vos besoins." },
    personal: "Vous préférez en parler en personne ?",
    personalLink: "Convenir d'un essai pour votre équipe",
  },
  form: {
    name: "Nom",
    email: "E-mail",
    phone: "Téléphone",
    company: "Entreprise",
    model: "Modèle",
    modelPlaceholder: "Choisir un modèle (optionnel)",
    consultation: "Conseil souhaité",
    date: "Date souhaitée",
    message: "Message",
    messagePlaceholder: "Votre message …",
    namePlaceholder: "Prénom et nom",
    privacy: "En envoyant ce formulaire, vous acceptez que nous vous contactions au sujet de votre demande.",
    submitProbefahrt: "Demander un essai",
    submitKontakt: "Envoyer le message",
    submitFlotte: "Envoyer la demande de flotte",
    sending: "Envoi en cours …",
    successProbefahrt: "Merci beaucoup ! Nous vous recontactons sous 24 heures pour votre essai routier.",
    successKontakt: "Merci pour votre demande ! Nous vous répondrons au plus vite.",
  },
  status: {
    available: "Disponible",
    orderable: "Sur commande",
    soon: "Bientôt disponible",
    onRequest: "Sur demande",
  },
  priceOnRequest: "Prix sur demande",
  models: {
    be11: {
      category: "SUV électrique",
      tagline: "Le SUV 100 % électrique – passer à l'électrique, tout simplement.",
      description: "Le Skywell BE11 facilite le passage à l'électrique : grande autonomie, recharge rapide et plus de 30 systèmes d'assistance intelligents. S'y ajoutent un habitacle spacieux et haut de gamme ainsi qu'un équipement qui ne laisse rien à désirer – de la caméra 360° au toit ouvrant panoramique.",
      features: [
        "Écran tactile 12.8\" + écran conducteur numérique 12.3\"",
        "Apple CarPlay & Android Auto (sans fil)",
        "Caméra panoramique 360° & aide au stationnement",
        "Plus de 30 systèmes d'aide à la conduite (ADAS) : dont ACC, AEB, LKA, RCTA",
        "Toit ouvrant panoramique (ouvrant)",
        "Sièges avant chauffants & ventilés, fonction mémoire",
        "Recharge sans fil du smartphone, prise 230 V (V2L)",
        "Hayon électrique avec ouverture mains libres",
      ],
      specs: [
        ["Batterie", "72 kWh / 86 kWh"],
        ["Autonomie (WLTP)", "jusqu'à 489 km"],
        ["Puissance", "150 kW (204 ch) / 320 Nm"],
        ["Recharge rapide DC", "jusqu'à 80 kW (10–80 % en env. 36–45 min)"],
        ["Recharge AC", "11 kW"],
        ["Transmission", "Traction avant"],
        ["Longueur × largeur × hauteur", "4'720 × 1'908 × 1'696 mm"],
        ["Empattement", "2'800 mm"],
        ["Coffre", "689–1'608 litres"],
        ["Vehicle-to-Load (V2L)", "Oui – prise 230 V à bord"],
        ["Infodivertissement", "Écran tactile 12.8\" + écran conducteur 12.3\""],
        ["Système audio", "Metz® avec 8 haut-parleurs & caisson de basses"],
        ["Garantie", "Garantie constructeur de 7 ans"],
      ],
    },
    "ht-i": {
      category: "SUV hybride rechargeable",
      tagline: "Électrique au quotidien, serein sur les longs trajets.",
      description: "Le Skyworth HT-i associe un moteur 1.5 litre efficient à une puissante motorisation électrique. Au quotidien, vous roulez 100 % électrique – en voyage, la motorisation hybride offre une autonomie totale allant jusqu'à 1'267 km. Le véhicule idéal pour celles et ceux qui veulent de la flexibilité sans planifier les recharges.",
      features: [
        "Conduite 100 % électrique au quotidien",
        "Aucune planification de recharge sur longue distance",
        "Habitacle de SUV généreux",
        "Infodivertissement moderne & systèmes d'assistance",
      ],
      specs: [
        ["Motorisation", "Hybride rechargeable (1.5 l + moteur électrique)"],
        ["Autonomie totale", "jusqu'à 1'267 km (donnée constructeur)"],
        ["Autonomie 100 % électrique", "jusqu'à env. 200 km (donnée constructeur)"],
        ["Carrosserie", "SUV 5 portes, 5 places"],
        ["Garantie", "Garantie constructeur – détails sur demande"],
      ],
    },
    ce11: {
      category: "SUV électrique de luxe",
      tagline: "Luxe et prestance – le fleuron de la gamme Skyworth.",
      description: "Le Skyworth CE11 redéfinit le luxe électrique : un habitacle panoramique généreux, un écran de plafond incurvé escamotable et 21 haut-parleurs créent une expérience immersive. Avec Smart AI (Swaiot GPT), le véhicule devient un compagnon intelligent.",
      features: [
        "Habitacle panoramique généreux",
        "Écran de plafond incurvé escamotable",
        "21 haut-parleurs pour une expérience sonore immersive",
        "Assistant vocal Smart AI · Swaiot GPT",
        "Matériaux et finition luxueux",
      ],
      specs: [
        ["Motorisation", "100 % électrique"],
        ["Carrosserie", "SUV de luxe"],
        ["Système audio", "21 haut-parleurs"],
        ["Autres données techniques", "à suivre prochainement"],
      ],
    },
    ev6: {
      category: "SUV électrique",
      tagline: "Le SUV électrique éprouvé de la première génération Skyworth.",
      description: "Le Skyworth EV6 est le SUV électrique éprouvé avec lequel la marque a conquis le marché international. Technologie fiable, habitacle généreux avec toit ouvrant panoramique et système de connectivité SKYLINK : un choix solide pour entrer dans l'électromobilité.",
      features: [
        "SKYLINK Intelligent Networking – voiture & maison connectées",
        "Toit ouvrant panoramique",
        "Assistance à la conduite L2.5 avec plus de 15 fonctions",
        "Système audio & vidéo immersif",
        "Habitacle généreux avec configurations de sièges flexibles",
      ],
      specs: [
        ["Motorisation", "100 % électrique"],
        ["Batterie", "60.2 kWh"],
        ["Autonomie", "jusqu'à 434 km (NEDC)"],
        ["Accélération 0–100 km/h", "6.7 s"],
        ["Recharge rapide DC", "20–70 % en ≤ 32 min"],
        ["Carrosserie", "SUV 5 portes, 5 places"],
        ["Garantie", "Garantie constructeur – détails sur demande"],
      ],
    },
    hongtu: {
      category: "Fourgon électrique",
      tagline: "Fourgon 100 % électrique pour la logistique professionnelle.",
      description: "Le Skyworth HONGTU V9 est le fourgon 100 % électrique pour la logistique urbaine et la livraison du dernier kilomètre : jusqu'à 14 m³ de volume de chargement, plus de 1'400 kg de charge utile et jusqu'à 408 km d'autonomie. Grâce à la recharge rapide DC de 120 kW, il est de nouveau opérationnel en 36 minutes environ – zéro émission, zéro compromis.",
      features: [
        "Deux variantes de carrosserie : L2H2 et L3H4",
        "Largeur de chargement de 1'403 mm entre les passages de roues",
        "Design aérodynamique (cx 0.29) pour une grande efficience",
        "Recharge rapide DC pour des temps d'arrêt minimaux",
        "Idéal pour la logistique urbaine, l'artisanat et le dernier kilomètre",
        "Également disponible en Passenger Van (version passagers)",
      ],
      specs: [
        ["Motorisation", "100 % électrique, 150 kW (204 ch) / 370 Nm"],
        ["Batterie", "jusqu'à 100.9 kWh (CATL)"],
        ["Autonomie (WLTP)", "jusqu'à 408 km"],
        ["Recharge rapide DC", "jusqu'à 120 kW (20–80 % en env. 36 min)"],
        ["Volume de chargement", "9 m³ (L2H2) / 14 m³ (L3H4)"],
        ["Charge utile", "jusqu'à 1'464 kg"],
        ["Poids total autorisé", "4'250 kg"],
        ["Longueur × largeur × hauteur", "5'490–5'990 × 1'990 × 2'200–2'700 mm"],
        ["Coefficient de traînée", "cx 0.29"],
        ["Garantie", "Garantie constructeur – détails sur demande"],
      ],
    },
    "hongtu-passenger": {
      category: "Minibus électrique",
      tagline: "Espace. Confort. Efficience – la navette électrique.",
      description: "Le Skyworth HONGTU Passenger Van transporte jusqu'à 17 personnes en silence et sans émissions – idéal pour les navettes d'hôtel, les transferts aéroportuaires et les entreprises. Avec 2'025 mm de hauteur sous plafond, des sièges individuels confortables (avec fonction massage en option) et des systèmes d'assistance modernes, votre groupe voyage en toute sérénité. La grande batterie et la recharge rapide de 120 kW réduisent les temps d'arrêt au minimum.",
      features: [
        "Jusqu'à 17 places assises pour navettes et transports de groupe",
        "Sièges individuels confortables, avec fonction massage en option",
        "Hauteur debout de 2'025 mm – montée et descente aisées",
        "Motorisation silencieuse et sans émissions pour navettes d'hôtel & urbaines",
        "Plateforme modulaire : également disponible en Cargo Van",
      ],
      specs: [
        ["Motorisation", "100 % électrique, jusqu'à 150 kW (204 ch), propulsion"],
        ["Batterie", "jusqu'à 100.9 kWh (CATL)"],
        ["Autonomie (WLTP)", "jusqu'à env. 408 km"],
        ["Recharge rapide DC", "jusqu'à 120 kW (20–80 % en env. 36 min)"],
        ["Places assises", "jusqu'à 17 (selon configuration)"],
        ["Hauteur intérieure", "2'025 mm de hauteur debout"],
        ["Infodivertissement", "Écran central 12.8\""],
        ["Systèmes d'assistance", "Aide à la conduite L2+ (ADAS)"],
        ["Garantie", "Garantie constructeur – détails sur demande"],
      ],
    },
  },
};
